import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaStore, FaSearch, FaTimes } from "react-icons/fa";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

const UserTable = ({ users, setUsers }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;
  const [showModal, setShowModal] = useState(false);
  const [showShop, setShowShop] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [id, setId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [toast, setToast] = useState(null);

  const [formData, setFormData] = useState({
    Email: "", Message: "", Shop_Name: "", Rate_Date: "",
    item1: "", item2: "", item3: "", item4: "", item5: "", item6: "", item7: "",
    item1_Price: "", item2_Price: "", item3_Price: "", item4_Price: "",
    item5_Price: "", item6_Price: "", item7_Price: "",
  });

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleDelete = async (rowId) => {
    try {
      await axios.delete(`/server/baos_function/shops/${rowId}`);
      setUsers((prev) => prev.filter((u) => u.ROWID !== rowId));
      showToast("User deleted successfully.");
    } catch {
      showToast("Error deleting user.", "error");
    }
  };

  const handleEdit = (user) => { setSelectedUser(user); setShowModal(true); };

  const handleShop = async (user) => {
    try {
      const res = await axios.get(`/server/baos_function/getRates/${user.Email}`);
      const rates = res.data.data;
      if (rates?.length > 0 && rates[0].Jewel_Rate) {
        const r = rates[0].Jewel_Rate;
        setFormData({
          Email: r.Email || user.Email, Message: r.Message || "", Shop_Name: r.Shop_Name || user.Shop_Name,
          Rate_Date: r.Rate_Date || "",
          item1: r.item1||"", item2: r.item2||"", item3: r.item3||"", item4: r.item4||"",
          item5: r.item5||"", item6: r.item6||"", item7: r.item7||"",
          item1_Price: r.item1_Price||"", item2_Price: r.item2_Price||"",
          item3_Price: r.item3_Price||"", item4_Price: r.item4_Price||"",
          item5_Price: r.item5_Price||"", item6_Price: r.item6_Price||"", item7_Price: r.item7_Price||"",
        });
        setId(r.ROWID);
      } else {
        setFormData((p) => ({ ...p, Email: user.Email, Shop_Name: user.Shop_Name || "" }));
        setId(null);
      }
      setShowShop(true);
    } catch { showToast("Error fetching shop rates.", "error"); }
  };

  const handleToggle = async (rowId, status) => {
    try {
      await axios.post("/server/baos_function/toggleStatus", { id: rowId, status });
      setUsers((prev) => prev.map((u) => u.ROWID === rowId ? { ...u, Active: status } : u));
      showToast("Status updated.");
    } catch { showToast("Error updating status.", "error"); }
  };

  const handleSave = async () => {
    try {
      await axios.post(`/server/baos_function/updateUser/${selectedUser.ROWID}`, selectedUser);
      setUsers((prev) => prev.map((u) => u.ROWID === selectedUser.ROWID ? selectedUser : u));
      showToast("User updated successfully.");
      setShowModal(false);
    } catch { showToast("Error updating user.", "error"); }
  };

  const handleShopSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("data", JSON.stringify(formData));
      const url = id ? `/server/baos_function/updateRate/${id}` : `/server/baos_function/addRate`;
      const res = await axios.post(url, form, { headers: { "Content-Type": "multipart/form-data" } });
      if (res.status === 200) {
        showToast("Rates saved successfully.");
        setIsEditing(false);
        if (!id && res.data.data?.ROWID) setId(res.data.data.ROWID);
      }
    } catch { showToast("Error saving rates.", "error"); }
  };

  const filtered = users.filter((u) =>
    Object.values(u).some((v) => String(v).toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const paginated = filtered.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    <>
      <style>{`
        @keyframes ut-fade { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes ut-modal-in { from{opacity:0;transform:translateY(22px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }

        .ut-toast {
          position:fixed;top:20px;right:22px;z-index:3000;
          padding:12px 20px;border-radius:12px;font-size:14px;font-weight:500;color:#fff;
          display:flex;align-items:center;gap:10px;animation:ut-fade .3s ease;
          box-shadow:0 8px 24px rgba(0,0,0,.18);max-width:320px;
        }
        .ut-toast.success{background:linear-gradient(135deg,#0B2E33,#4F7C82);}
        .ut-toast.error{background:linear-gradient(135deg,#931B5B,#6b1443);}

        .ut-table-card {
          background:#fff;border-radius:12px;padding:20px;
          box-shadow:0 4px 14px rgba(0,0,0,.06);border:1.5px solid #CBCBCB;
        }
        .ut-toolbar {
          display:flex;align-items:center;justify-content:space-between;
          margin-bottom:16px;flex-wrap:wrap;gap:12px;
        }
        .ut-table-title { font-size:15px;font-weight:700;color:#0B2E33; }
        .ut-table-sub { font-size:11px;color:#9ca3af;margin-top:1px; }
        .ut-search {
          display:flex;align-items:center;gap:8px;
          background:#F2F2F2;border-radius:10px;padding:7px 12px;
          border:1.5px solid transparent;transition:all .2s;max-width:240px;width:100%;
        }
        .ut-search:focus-within{background:#fff;border-color:#0B2E33;box-shadow:0 0 0 3px rgba(11,46,51,.1);}
        .ut-search input{border:none;background:transparent;outline:none;font-size:13px;color:#0B2E33;width:100%;}
        .ut-search input::placeholder{color:#CBCBCB;}

        .ut-scroll { overflow-x:auto; }
        table.ut-table { width:100%;border-collapse:separate;border-spacing:0;min-width:800px; }
        .ut-table thead tr {background:linear-gradient(135deg,#F2F2F2,#e5e5e5);}
        .ut-table th {
          padding:10px 12px;font-size:10px;font-weight:700;
          color:#4F7C82;text-transform:uppercase;letter-spacing:0.8px;
          text-align:left;white-space:nowrap;
        }
        .ut-table th:first-child{border-radius:8px 0 0 8px;}
        .ut-table th:last-child{border-radius:0 8px 8px 0;}
        .ut-table tbody tr {
          transition:background .15s;
          border-bottom:1px solid #F2F2F2;
        }
        .ut-table tbody tr:hover{background:#fafafa;}
        .ut-table td {padding:10px 12px;font-size:12.5px;color:#1a1a1a;vertical-align:middle;}

        .ut-badge {
          display:inline-flex;align-items:center;gap:4px;
          padding:3px 8px;border-radius:20px;font-size:10px;font-weight:700;
        }
        .ut-badge.active{background:#d9ecee;color:#0B2E33;}
        .ut-badge.inactive{background:#fde8f2;color:#931B5B;}

        .ut-switch{position:relative;display:inline-block;width:34px;height:18px;}
        .ut-switch input{opacity:0;width:0;height:0;}
        .ut-slider{
          position:absolute;cursor:pointer;inset:0;
          background:#CBCBCB;border-radius:20px;transition:.3s;
        }
        .ut-slider:before{
          content:"";position:absolute;height:14px;width:14px;
          left:2px;bottom:2px;background:#fff;border-radius:50%;transition:.3s;
        }
        input:checked + .ut-slider{background:#0B2E33;}
        input:checked + .ut-slider:before{transform:translateX(16px);}

        .ut-icon-btn {
          width:28px;height:28px;border:none;border-radius:7px;cursor:pointer;
          display:inline-flex;align-items:center;justify-content:center;
          font-size:12px;transition:all .2s;margin:0 2px;
        }
        .ut-icon-btn.edit{background:#d9ecee;color:#0B2E33;}
        .ut-icon-btn.edit:hover{background:#0B2E33;color:#fff;}
        .ut-icon-btn.del{background:#fde8f2;color:#931B5B;}
        .ut-icon-btn.del:hover{background:#931B5B;color:#fff;}
        .ut-icon-btn.shop{background:#F2F2F2;color:#4F7C82;font-size:14px;}
        .ut-icon-btn.shop:hover{background:#4F7C82;color:#fff;}

        .ut-pagination{display:flex;gap:5px;justify-content:center;margin-top:16px;flex-wrap:wrap;}
        .ut-page-btn{
          width:30px;height:30px;border:none;border-radius:7px;
          font-size:12px;font-weight:600;cursor:pointer;transition:all .2s;
        }
        .ut-page-btn.active{background:#0B2E33;color:#fff;box-shadow:0 3px 8px rgba(11,46,51,.25);}
        .ut-page-btn:not(.active){background:#F2F2F2;color:#4F7C82;}
        .ut-page-btn:not(.active):hover{background:#CBCBCB;}

        /* Modals */
        .ut-overlay{
          position:fixed;inset:0;background:rgba(11,46,51,.4);
          z-index:1200;display:flex;align-items:center;justify-content:center;
          padding:20px;backdrop-filter:blur(3px);
        }
        .ut-modal{
          background:#fff;border-radius:16px;width:100%;max-width:500px;
          max-height:90vh;overflow-y:auto;
          box-shadow:0 20px 50px rgba(0,0,0,.2);
          animation:ut-modal-in .25s ease;
        }
        .ut-modal::-webkit-scrollbar{width:4px;}
        .ut-modal::-webkit-scrollbar-thumb{background:#CBCBCB;border-radius:8px;}
        .ut-modal-hdr{
          display:flex;align-items:center;justify-content:space-between;
          padding:18px 24px 14px;border-bottom:1px solid #F2F2F2;
          position:sticky;top:0;background:#fff;z-index:10;border-radius:16px 16px 0 0;
        }
        .ut-modal-title{font-size:16px;font-weight:700;color:#0B2E33;}
        .ut-modal-sub{font-size:11px;color:#9ca3af;margin-top:1px;}
        .ut-close-btn{
          width:30px;height:30px;background:#F2F2F2;border:none;border-radius:8px;
          display:flex;align-items:center;justify-content:center;
          font-size:12px;color:#4F7C82;cursor:pointer;transition:background .2s;flex-shrink:0;
        }
        .ut-close-btn:hover{background:#CBCBCB;}
        .ut-modal-body{padding:18px 24px;display:flex;flex-direction:column;gap:12px;}
        .ut-modal-body-grid{padding:18px 24px;display:grid;grid-template-columns:1fr 1fr;gap:14px;}
        .ut-field-label{font-size:10px;font-weight:700;color:#4F7C82;text-transform:uppercase;letter-spacing:.7px;margin-bottom:4px;}
        .ut-field-input{
          width:100%;padding:8px 12px;
          border:1.5px solid #CBCBCB;border-radius:8px;
          font-size:13px;color:#1a1a1a;outline:none;
          background:#F2F2F2;transition:all .2s;font-family:'Open Sans',sans-serif;
        }
        .ut-field-input:focus{border-color:#0B2E33;box-shadow:0 0 0 3px rgba(11,46,51,.08);background:#fff;}
        .ut-field-input:disabled{background:#e5e5e5;color:#9ca3af;cursor:not-allowed;}
        .ut-field-textarea{
          width:100%;padding:8px 12px;
          border:1.5px solid #CBCBCB;border-radius:8px;
          font-size:13px;color:#1a1a1a;outline:none;
          background:#F2F2F2;transition:all .2s;resize:vertical;min-height:70px;
          font-family:'Inter',sans-serif;
        }
        .ut-field-textarea:focus{border-color:#0B2E33;box-shadow:0 0 0 3px rgba(11,46,51,.08);background:#fff;}
        .ut-section-label{
          font-size:11px;font-weight:700;color:#0B2E33;
          text-transform:uppercase;letter-spacing:.9px;
          padding:0 0 6px 8px;border-left:3px solid #931B5B;
          grid-column:span 2;
        }
        .ut-modal-ftr{
          padding:14px 24px 18px;border-top:1px solid #F2F2F2;
          display:flex;gap:10px;justify-content:flex-end;
        }
        .ut-cancel-btn{
          padding:8px 16px;border:none;border-radius:9px;
          background:#F2F2F2;color:#0B2E33;font-size:13px;font-weight:600;cursor:pointer;
        }
        .ut-cancel-btn:hover{background:#CBCBCB;}
        .ut-save-btn{
          padding:8px 20px;border:none;border-radius:9px;
          background:linear-gradient(135deg,#0B2E33,#4F7C82);color:#fff;
          font-size:13px;font-weight:600;cursor:pointer;
          box-shadow:0 4px 12px rgba(11,46,51,.25);transition:opacity .2s;
        }
        .ut-save-btn:hover{opacity:.9;}
        .ut-danger-btn{
          padding:8px 20px;border:none;border-radius:9px;
          background:linear-gradient(135deg,#931B5B,#6b1443);color:#fff;
          font-size:13px;font-weight:600;cursor:pointer;
          box-shadow:0 4px 12px rgba(147,27,91,.2);transition:opacity .2s;
        }
        .ut-danger-btn:hover{opacity:.9;}
        .ut-empty{
          text-align:center;padding:50px 20px;color:#CBCBCB;
          font-size:13px;display:flex;flex-direction:column;gap:8px;align-items:center;
        }
        @media(max-width:600px){
          .ut-modal-body-grid{grid-template-columns:1fr;}
          .ut-section-label{grid-column:span 1;}
        }
      `}</style>

      {toast && <div className={`ut-toast ${toast.type}`}>{toast.type==="success"?"✅":"❌"} {toast.msg}</div>}

      <div className="ut-table-card">
        {/* Toolbar */}
        <div className="ut-toolbar">
          <div>
            <div className="ut-table-title">📋 Shop Owners</div>
            <div className="ut-table-sub">{filtered.length} records found</div>
          </div>
          <div className="ut-search">
            <FaSearch style={{color:"#CBCBCB",fontSize:12,flexShrink:0}} />
            <input
              type="text"
              placeholder="Search users…"
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <FaTimes
                style={{color:"#CBCBCB",fontSize:12,cursor:"pointer",flexShrink:0}}
                onClick={() => setSearchTerm("")}
              />
            )}
          </div>
        </div>

        {/* Table */}
        <div className="ut-scroll">
          <table className="ut-table">
            <thead>
              <tr>
                {["#","Name","Phone","Shop Name","Shop ID","Shop Pwd","Screen ID","Scr Pwd","Status","Actions","Shop"].map((h,i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginated.length === 0 ? (
                <tr><td colSpan={11}>
                  <div className="ut-empty"><span style={{fontSize:36}}>🔍</span> No users found</div>
                </td></tr>
              ) : paginated.map((user, idx) => (
                <tr key={user.ROWID || idx}>
                  <td style={{color:"#CBCBCB",fontWeight:600,fontSize:11}}>{(currentPage-1)*rowsPerPage+idx+1}</td>
                  <td style={{fontWeight:700,color:"#0B2E33"}}>{user.Name}</td>
                  <td>{user.Phone}</td>
                  <td>{user.Shop_Name}</td>
                  <td><code style={{background:"#F2F2F2",padding:"2px 6px",borderRadius:4,fontSize:11}}>{user.ShopID}</code></td>
                  <td><code style={{background:"#F2F2F2",padding:"2px 6px",borderRadius:4,fontSize:11}}>{user.Shop_Password}</code></td>
                  <td><code style={{background:"#F2F2F2",padding:"2px 6px",borderRadius:4,fontSize:11}}>{user.ScreenID}</code></td>
                  <td><code style={{background:"#F2F2F2",padding:"2px 6px",borderRadius:4,fontSize:11}}>{user.Screen_Password}</code></td>
                  <td>
                    <label className="ut-switch">
                      <input type="checkbox" checked={!!user.Active} onChange={() => handleToggle(user.ROWID, !user.Active)} />
                      <span className="ut-slider" />
                    </label>
                    <div style={{marginTop:4}}>
                      <span className={`ut-badge ${user.Active?"active":"inactive"}`}>
                        {user.Active ? "● Active" : "● Inactive"}
                      </span>
                    </div>
                  </td>
                  <td>
                    <button className="ut-icon-btn edit" onClick={() => handleEdit(user)} title="Edit"><FaEdit /></button>
                    <button className="ut-icon-btn del" onClick={() => { setUserToDelete(user); setShowDeleteModal(true); }} title="Delete"><FaTrash /></button>
                  </td>
                  <td>
                    <button className="ut-icon-btn shop" onClick={() => handleShop(user)} title="View Shop"><FaStore /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="ut-pagination">
            {Array.from({length: totalPages}, (_, i) => (
              <button key={i} className={`ut-page-btn ${currentPage===i+1?"active":""}`} onClick={() => setCurrentPage(i+1)}>
                {i+1}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Edit User Modal */}
      {showModal && selectedUser && (
        <div className="ut-overlay" onClick={(e) => e.target===e.currentTarget && setShowModal(false)}>
          <div className="ut-modal">
            <div className="ut-modal-hdr">
              <div><div className="ut-modal-title">✏️ Edit User</div><div className="ut-modal-sub">Update shop owner details</div></div>
              <button className="ut-close-btn" onClick={() => setShowModal(false)}><FaTimes /></button>
            </div>
            <div className="ut-modal-body">
              {["Name","Email","Shop_Name","ShopID","Shop_Password","ScreenID","Screen_Password"].map((field) => (
                <div key={field}>
                  <div className="ut-field-label">{field.replace(/_/g," ")}</div>
                  <input
                    className="ut-field-input"
                    name={field}
                    value={selectedUser[field] || ""}
                    onChange={(e) => setSelectedUser((p) => ({...p, [e.target.name]: e.target.value}))}
                    placeholder={field.replace(/_/g," ")}
                    disabled={field==="Email"}
                  />
                </div>
              ))}
            </div>
            <div className="ut-modal-ftr">
              <button className="ut-cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="ut-save-btn" onClick={handleSave}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* Shop Rates Modal */}
      {showShop && (
        <div className="ut-overlay" onClick={(e) => e.target===e.currentTarget && setShowShop(false)}>
          <div className="ut-modal">
            <div className="ut-modal-hdr">
              <div><div className="ut-modal-title">🏪 Shop Details & Rates</div><div className="ut-modal-sub">View and edit gold/silver rates for this shop</div></div>
              <div style={{display:"flex",gap:8}}>
                {isEditing
                  ? <button className="ut-close-btn" onClick={() => setIsEditing(false)} title="Cancel Edit"><CloseIcon style={{fontSize:16}} /></button>
                  : <button className="ut-close-btn" onClick={() => setIsEditing(true)} title="Edit"><EditIcon style={{fontSize:16}} /></button>
                }
                <button className="ut-close-btn" onClick={() => setShowShop(false)}><FaTimes /></button>
              </div>
            </div>
            <form onSubmit={handleShopSubmit}>
              <div className="ut-modal-body-grid">
                <div className="ut-section-label">Basic Information</div>
                <div>
                  <div className="ut-field-label">Shop Name</div>
                  <input className="ut-field-input" name="Shop_Name" value={formData.Shop_Name}
                    onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))} disabled={!isEditing} required />
                </div>
                <div>
                  <div className="ut-field-label">Rate Date</div>
                  <input className="ut-field-input" type="date" name="Rate_Date" value={formData.Rate_Date}
                    onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))} disabled={!isEditing} required />
                </div>
                <div style={{gridColumn:"span 2"}}>
                  <div className="ut-field-label">Registered Email</div>
                  <input className="ut-field-input" type="email" name="Email" value={formData.Email}
                    onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))} disabled required />
                </div>
                <div className="ut-section-label">Gold & Silver Rates</div>
                {[1,2,3,4,5,6,7].map((i) => (
                  <React.Fragment key={i}>
                    <div>
                      <div className="ut-field-label">Item {i} Label</div>
                      <input className="ut-field-input" name={`item${i}`} value={formData[`item${i}`]}
                        onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))}
                        placeholder="e.g. Gold 24K" disabled={!isEditing} required />
                    </div>
                    <div>
                      <div className="ut-field-label">Price / Value</div>
                      <input className="ut-field-input" name={`item${i}_Price`} value={formData[`item${i}_Price`]}
                        onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))}
                        placeholder="e.g. 7500" disabled={!isEditing} required />
                    </div>
                  </React.Fragment>
                ))}
                <div style={{gridColumn:"span 2"}}>
                  <div className="ut-field-label">Scroll Message</div>
                  <textarea className="ut-field-textarea" name="Message" value={formData.Message}
                    onChange={(e) => setFormData((p)=>({...p,[e.target.name]:e.target.value}))}
                    placeholder="Message to display on the digital board…" disabled={!isEditing} />
                </div>
              </div>
              <div className="ut-modal-ftr">
                <button type="button" className="ut-cancel-btn" onClick={() => setShowShop(false)}>Close</button>
                {isEditing && <button type="submit" className="ut-save-btn">Save Rates</button>}
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirm Modal */}
      {showDeleteModal && (
        <div className="ut-overlay" onClick={(e) => e.target===e.currentTarget && setShowDeleteModal(false)}>
          <div className="ut-modal" style={{maxWidth:340,textAlign:"center"}}>
            <div style={{padding:"30px 24px 24px"}}>
              <div style={{fontSize:42,marginBottom:14}}>🗑️</div>
              <div className="ut-modal-title" style={{marginBottom:8}}>Delete User</div>
              <p style={{fontSize:13,color:"#6b7280",lineHeight:1.5}}>
                Are you sure you want to delete <strong style={{color:"#0B2E33"}}>{userToDelete?.Name}</strong>? This action cannot be undone.
              </p>
              <div style={{display:"flex",gap:10,marginTop:24}}>
                <button className="ut-cancel-btn" style={{flex:1}} onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button className="ut-danger-btn" style={{flex:1}} onClick={() => { handleDelete(userToDelete.ROWID); setShowDeleteModal(false); }}>Yes, Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserTable;
